import type { CapacityAttentionItem } from "@/types/capacity";

const CALENDAR_MODES = ["day", "week", "quarter"];
const CATEGORY_FILTERS = ["all", "unallocated", "allocated", "out_of_sync"];

/** Capacity attention items the Dashboard shows at most (the phone's strip and the capacity page: 3). */
export const DASHBOARD_CAPACITY_ATTENTION_ROWS = 3;

/**
 * The capacity planner URL behind one attention item (#2175 C4): the server's
 * deep link (view, date, group, filter), as the planner's own attention strip
 * applies it. Unknown views and filters are dropped, not written to the URL.
 */
export function capacityAttentionHref(item: CapacityAttentionItem): string {
  const link = item.deep_link;
  const params = new URLSearchParams();
  if (link?.view && CALENDAR_MODES.includes(link.view)) params.set("calendarMode", link.view);
  if (link?.date) {
    params.set("date", link.date);
    params.set("calendarDate", link.date);
  }
  const groupId = link?.group_id ?? item.group_id;
  if (groupId) params.set("overviewGroupId", groupId);
  if (link?.filter && CATEGORY_FILTERS.includes(link.filter)) params.set("filter", link.filter);
  const query = params.toString();
  return query ? `/capacity?${query}` : "/capacity";
}
